var React = require('react');

function IconMinusBase (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":".Minus Base"},React.createElement("path",{"id":"Path","d":"M22 12H2","stroke":"#142B6F","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"})));
}

IconMinusBase.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconMinusBase;

IconMinusBase.default = IconMinusBase;
